import axios from 'axios';
import { config } from '@/config';

/**
 * Lee las credenciales actuales del admin desde localStorage.
 *
 * @returns {{ token: string, hashTeatro: string }}
 */
export function getAdminCredentials() {
    return {
        token: localStorage.getItem('token') || '',
        hashTeatro: localStorage.getItem('hash_teatro') || '',
    };
}

/**
 * Añade las credenciales del admin a una URL absoluta o relativa.
 *
 * @param {string} url
 * @returns {string}
 */
export function withAdminCredentials(url) {
    if (!url) return '';

    const { token, hashTeatro } = getAdminCredentials();
    const separator = url.includes('?') ? '&' : '?';

    return `${url}${separator}api_key=${token}${hashTeatro ? `&tid=${hashTeatro}` : ''}`;
}

/**
 * Crea un cliente axios para la API del admin.
 *
 * Lee token y hash_teatro de localStorage en el momento de la llamada
 * para garantizar que siempre se usan credenciales frescas.
 *
 * Inyecta automáticamente api_key como query param en todas las requests
 * (mismo comportamiento que el legacy api.js).
 *
 * @returns {import('axios').AxiosInstance}
 */
export function createAdminApiClient() {
    const { token, hashTeatro } = getAdminCredentials();

    const client = axios.create({
        baseURL: config.API_BASE,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': token,
            'Hash-Teatro': hashTeatro,
        },
    });

    // Inyecta api_key como query param en todas las peticiones (mismo comportamiento que legacy api.js)
    // Lee el token fresco en cada request para no usar credenciales stale
    client.interceptors.request.use(cfg => {
        const creds = getAdminCredentials();
        if (creds.token) {
            cfg.params = {
                ...(cfg.params || {}),
                api_key: creds.token,
            };
        }
        return cfg;
    });

    return client;
}
